export interface TokenStorage {
    [ACCESS_TOKEN]: string;
    [REFRESH_TOKEN]: string;
    [EXPIRES_IN]: string;
}

export const ACCESS_TOKEN = 'token';
export const REFRESH_TOKEN = 'tokenRefresh';
export const EXPIRES_IN = 'expiresIn';